import { createFileRoute } from "@tanstack/react-router";
import { requireSession } from "../shell-handle/bootGate";

export const Route = createFileRoute("/")({
  beforeLoad: () => requireSession(),
  component: () => {
    if (
      typeof window !== "undefined" &&
      window.location.pathname !== "/welcome"
    ) {
      window.location.replace("/welcome");
    }
    return null;
  },
});
